module.exports = {
  PoNo: 'หมายเลขคำสั่งซื้อ',
  ItemNo: 'รหัส SKU',
  JobNo: 'เลขที่งานขนส่งหลัก',
  Supplier: 'ผู้จัดหา',
  LoadingPort: 'ท่าเรือต้นทาง',
  DestinationPort: 'ท่าเรือปลายทาง',
  WarehouseNo: 'เลขที่รับเข้าคลัง',
  State: 'สถานะ',
  OperationRequirement: 'ข้อกำหนดการดำเนินการ',
  RequestedIncomeDate: 'เวลาที่กำหนดให้รับเข้าคลัง',
  EstimatedIncomeDate: 'เวลารับเข้าคลังที่คาดการณ์',
  ETD: 'เวลาออกจากท่าเรือที่คาดการณ์',
  LoadingDate: 'เวลาบรรจุหีบห่อเสร็จสิ้น',
  RequestedDeliveryDate: 'เวลาส่งมอบที่กำหนด',
  EstimatedDeliveryDate: 'เวลาส่งมอบที่คาดการณ์',
  POCreationDate: 'เวลาสร้าง PO',
  DeliveryDate: 'เวลารับ',
  DateModified: 'เวลาอัปเดต',
  Producer: 'ผู้ผลิต',
  PackageEstimatedIncomeDate: 'เวลาที่คาดว่าสินค้าจะพร้อม',
  IncomeDate: 'เวลารับเข้าคลังจริง',
  WarehouseInState: 'สถานะการรับเข้าคลัง',
  DeliveryAddr: 'ที่อยู่รับสินค้า',
  IncomeDelayReason: 'สาเหตุการล่าช้าในการรับเข้าคลัง',
  ContainerState: 'สถานะตู้คอนเทนเนอร์',
  DepartureDelayReason: 'สาเหตุการล่าช้าในการออกจากท่าเรือ',
  PleaseSelectTheOrderToDelete: 'กรุณาเลือกคำสั่งซื้อที่ต้องการลบ',
  onlyOneOrderCanBeDeletedAtATime: 'สามารถลบได้ครั้งละหนึ่งคำสั่งซื้อเท่านั้น',
  onlyCancelledOrdersCanBeDeleted: 'สามารถลบได้เฉพาะคำสั่งซื้อที่ยกเลิกแล้ว',
  areYouSureToDeleteThisOrder: 'แน่ใจหรือไม่ที่จะลบคำสั่งซื้อนี้?',
  deleteOrder: 'ลบคำสั่งซื้อ',
  Shipper: 'ผู้ส่งสินค้า',
  RelatedParty: 'ภาคีที่เกี่ยวข้อง',
  Consignee: 'ผู้รับสินค้า',
  EntrustingDate: 'วันที่มอบหมาย'
}
